import { TextField } from "@mui/material";
import { getIn } from "formik";

export function InputText({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  size = "small",
  variant = "outlined",
  ...props
}) {
  return (
    <>
      <TextField
        size={size}
        type={type}
        name={field.name}
        label={label}
        variant={variant}
        onBlur={handleBlur}
        onChange={handleChange}
        helperText={getIn(touched, field.name) && getIn(errors, field.name)}
        error={Boolean(getIn(touched, field.name) && getIn(errors, field.name))}
        {...field}
        {...props}
      />
    </>
  );
}
